import { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { AnimatePresence, motion } from "framer-motion";

const LINKS = [
  { to: "/", label: "Home", testid: "nav-home-link" },
  { to: "/about", label: "About Roy", testid: "nav-about-link" },
  { to: "/working-with-me", label: "Working With Me", testid: "nav-working-link" },
  { to: "/creatives", label: "For Creatives", testid: "nav-creatives-link" },
  { to: "/book", label: "Conversations", testid: "nav-book-link" },
  { to: "/contact", label: "Contact", testid: "nav-contact-link" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  return (
    <header
      data-testid="site-header"
      className="fixed top-0 left-0 right-0 z-50 border-b border-gold/25 bg-paper/85 backdrop-blur-xl"
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 lg:px-10">
        <Link to="/" data-testid="nav-logo-link" className="group flex items-center gap-3">
          <span className="flex h-10 w-10 items-center justify-center border border-golddeep/60 font-serif text-lg font-bold text-golddeep transition-colors duration-300 group-hover:bg-gold group-hover:text-ink">
            RB
          </span>
          <span className="hidden sm:block">
            <span className="block font-serif text-lg font-semibold leading-tight text-ink">
              Roy Buncome
            </span>
            <span className="block font-mono text-[10px] uppercase tracking-[0.3em] text-golddeep">
              Strategy Architect
            </span>
          </span>
        </Link>

        <nav className="hidden items-center gap-8 lg:flex" data-testid="nav-desktop">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={l.testid}
              className={({ isActive }) =>
                `text-sm tracking-wide transition-colors duration-300 hover:text-golddeep ${
                  isActive ? "text-golddeep font-semibold" : "text-slate-600"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <Link to="/book" data-testid="nav-book-call-btn" className="btn-gold !px-5 !py-2.5">
            Book a 20-Min Call
          </Link>
        </nav>

        <button
          data-testid="nav-mobile-toggle"
          className="text-ink lg:hidden"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.nav
            data-testid="nav-mobile"
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.35 }}
            className="overflow-hidden border-t border-gold/25 bg-paper lg:hidden"
          >
            <div className="flex flex-col gap-1 px-6 py-4">
              {LINKS.map((l) => (
                <NavLink
                  key={l.to}
                  to={l.to}
                  data-testid={`${l.testid}-mobile`}
                  onClick={() => setOpen(false)}
                  className={`py-2.5 text-sm ${
                    location.pathname === l.to ? "text-golddeep font-semibold" : "text-slate-600"
                  }`}
                >
                  {l.label}
                </NavLink>
              ))}
              <Link
                to="/book"
                data-testid="nav-book-call-btn-mobile"
                onClick={() => setOpen(false)}
                className="btn-gold mt-3"
              >
                Book a 20-Min Call
              </Link>
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
};
